import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled, { css } from "styled-components";

import media, { useScreenSize } from "@/utils/media";
import { Row, Col } from "antd";
//

const MainWrap = styled.div`
  display: flex;
  min-width: 100%;
  justify-content: flex-start;
  flex-direction: column;
`;
const OptionWrap = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 16px 5px 0;
  @media (max-width: 420px) {
   margin-right: 0px;
}    
  padding: 10px;
  min-height: 52px;
  background-color: #fff;
  border-radius: 15px;
  border: 2px solid #f0f0f0;
  cursor: pointer;
  position: relative;
  min-width: 80%;
  max-width: 100%;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: #404040;
  // color: #303030;
  font-weight: 700;
  p {
    margin-bottom: 0;
  }
  img {
    filter: invert(1) sepia(1) saturate(5) hue-rotate(106deg);
  }
  
  .svg-inline--fa {
    font-size: 20px;
  }


  &[disabled] {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
  .icon-wrap {
    flex-shrink: 0;
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid var(--primary-main-color);
    margin-right: 12px;
    opacity: 0.5;
  }

  ${(props) =>
    props.isSelected &&
    css`
      border: 2px solid var(--primary-main-color);
      background-color: var(--primary-main-color);
      color: #fff;
      .icon-wrap {
        opacity: 1;
      }
    `}

  p {
    font-size: 10px;
    color: #a0a0a0;
    font-weight: 300;
    font-family: "Montserrat";
  }
`;
const OptionWraps = styled.div`
  width:100%;
  height: 40px;
`
export default function InlineSelector({ options = [], onChange, value }) {
  function renderOption(option) {
    const isSelected = option.value === value;
    const isDisabled = option.disabled;

    return (
      <OptionWrap
        disabled={isDisabled}
        isSelected={isSelected}
        onClick={() => onChange(option.value)}
      >
        {/* <div className="icon-wrap">
          <img src={option.icon}/>

        </div> */}
        <div>
          {option.label}
          {/* <p>{option.description}</p> */}
        </div>
      </OptionWrap>
    );
  }
  return <MainWrap>{options.map(renderOption)}</MainWrap>;
}
